/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoAccountPaymentIndicator implements angular.IDirective {
        dataService: Meevo.Components.BaseClasses.IDataService;
        appSettings: Meevo.Components.Common.IAppSettings;
        securityService: Meevo.Components.Common.ISecurityService;
        $translate: angular.translate.ITranslateService;
        $filter: angular.IFilterService;
        $rootScope: ng.IRootScopeService;
        restrict = "E";
        scope = {
            clientId: "=",
            isHeader: "=?",
        };
        templateUrl = "app/components/controls/clientAccountPaymentIndicatorTemplate.html";

        link = (scope: any) => {
            scope.showAccountToolTip = false;  

            scope.openClientAccount = (): void => {

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {                   
                    stateName: this.appSettings.ROUTE_NAMES.client,
                    stateParams: {
                        callback: null,
                        callbackState: null,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                        initialEditSection: 'SECTION_HISTORY',
                        initialEditSubSection: 'ACCOUNT_HISTORY',                       
                        id: scope.clientId
                    },
                });
                scope.showAccountToolTip = false;
            }
            
            scope.$watch('clientId', clientId => {
                if (clientId) { 
                    //scope.accountPaymentIndicatorUrl = "assets/images/icons/account_balance_positive_universal.svg";
                    scope.hasClientAccount = false;
                    if (!scope.clientId || scope.clientId.length === 0) {
                        return;
                    }

                    this.dataService.getItem("client", new Guid(scope.clientId), "accountbalance").then((response: any) => {
                        scope.accountBalance = +response.accountBalance;
                        scope.hasClientAccount = response.allowChargesCreditOnAccount;
                        scope.accountPaymentIndicatorUrl = scope.accountBalance > 0 ? "assets/images/icons/account_balance_positive_universal.svg" : scope.accountBalance < 0 ?"assets/images/icons/account_balance_negative_universal.svg":"";
                    });               
                }
            });
        }

        constructor($rootScope: ng.IRootScopeService, appSettings: Meevo.Components.Common.IAppSettings, dataService: Meevo.Components.BaseClasses.IDataService, securityService: Meevo.Components.Common.ISecurityService, $translate: angular.translate.ITranslateService, $filter: angular.IFilterService) {
            this.dataService = dataService;
            this.$rootScope = $rootScope;
            this.appSettings = appSettings;
            this.securityService = securityService;
            this.$translate = $translate;
            this.$filter = $filter;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: ng.IRootScopeService,
                appSettings: Meevo.Components.Common.IAppSettings,
                dataService: Meevo.Components.BaseClasses.IDataService,
                securityService: Meevo.Components.Common.ISecurityService,
                $translate: angular.translate.ITranslateService,
                $filter: angular.IFilterService) => {
                return new MeevoAccountPaymentIndicator($rootScope, appSettings, dataService, securityService, $translate, $filter);
            }

            directive.$inject = ["$rootScope", "meevo.AppSettings", "meevo.components.common.DataService", "meevo.components.common.SecurityService", "$translate","$filter"];
            return directive;
        }
    }

    angular.module('meevo.components.controls').directive("meevoAccountPaymentIndicator", MeevoAccountPaymentIndicator.factory());
}